module.exports = __webpack_public_path__ + "img/back_arrow.372b2208.png";